import { SignUpAction } from './actions';
import ActionType, { SignupMethod, SignupStatus, TextFieldStatus } from './types';

interface SignupFieldValue {
  value: string;
  status: TextFieldStatus;
}

export interface SignUpFormState {
  email: SignupFieldValue;
  phoneNumber: SignupFieldValue;
  password: SignupFieldValue;
  status: SignupStatus;
  signupSessionId: string;
  signupMethod: SignupMethod;
}

export const initialState: () => SignUpFormState = () => {
  return {
    email: {
      value: '',
      status: 'empty'
    },
    phoneNumber: {
      value: '',
      status: 'empty'
    },
    password: {
      value: '',
      status: 'empty'
    },
    status: 'not_signup',
    signupSessionId: '',
    signupMethod: SignupMethod.Email
  };
};

const reducer = (state: SignUpFormState = initialState(), action: SignUpAction): SignUpFormState => {
  switch (action.type) {
    case ActionType.updateEmail: {
      return { ...state, status: 'not_signup', email: { value: action.payload, status: 'valid' } };
    }
    case ActionType.validateSignupEmail: {
      return { ...state, email: { ...state.email, status: action.payload } };
    }
    case ActionType.updatePhoneNumber: {
      return { ...state, status: 'not_signup', phoneNumber: { value: action.payload, status: 'valid' } };
    }
    case ActionType.validateSignupPhoneNumber: {
      return { ...state, phoneNumber: { ...state.phoneNumber, status: action.payload } };
    }
    case ActionType.updatePassword: {
      return { ...state, status: 'not_signup', password: { value: action.payload, status: 'valid' } };
    }
    case ActionType.validateSignupPassword: {
      return { ...state, password: { ...state.password, status: action.payload } };
    }
    case ActionType.startToSignup: {
      const newState = { ...state };
      newState.status = 'signup_loading';
      return newState;
    }
    case ActionType.signupSuccess: {
      const newState = { ...state };
      newState.status = 'signup';
      newState.signupSessionId = action.payload;
      return newState;
    }
    case ActionType.signupFailed: {
      const newState = { ...state };
      newState.status = action.payload;
      return newState;
    }
    case ActionType.clearSignupStatus: {
      return initialState();
    }
    case ActionType.changeSignupMethod: {
      return {
        ...state,
        signupMethod: action.payload,
        email: { value: '', status: 'empty' },
        phoneNumber: { value: '', status: 'empty' },
        status: 'not_signup'
      };
    }
    default:
      ((_: never) => {
        return;
      })(action);
      return state;
  }
};

export default reducer;
